// import node module libraries
import React from 'react';
import { Link } from 'react-router-dom';
import { Row, Col, Card, ListGroup } from 'react-bootstrap';

// import translations
import { useTranslation } from 'react-i18next';

// import data files
import RecentActivityData from 'data/dashboard/projects/RecentActivityData';

const RecentActivity = ({item, onReload}) => {
	const { t } = useTranslation();

	return (
		<Card>
			{/* Card header */}
			<Card.Header className="card-header-height d-flex justify-content-between align-items-center">
				<div>
					{' '}
					<h4 className="mb-0">{t('Recent Flow Activity')}</h4>
				</div>
				<div>
					<Link onClick={onReload} className="">
						<i className="fe fe-rotate-cw ms-2 text-muted"></i>
					</Link>
				</div>
			</Card.Header>

			{/* Card body */}
			<Card.Body>
				{/* List group */}
				<ListGroup variant="flush" className="list-timeline-activity">
					{/* Check if item is empty */}
					{item.length === 0 ? (
						<div className="text-center p-3">{t('No Flow activies found')}</div>
					) : (
						<>
							{item.slice(0, 4).map((item, index) => {
								// Helper function to format the timestamp
								const formatTimestamp = (timestamp) => {
									// Convert "YYYY-MM-DD HH:mm:ss" to "YYYY-MM-DDTHH:mm:ss"
									const isoString = timestamp.replace(' ', 'T');
									const date = new Date(isoString);
									const now = new Date();
									const dateOnly = new Date(date.getFullYear(), date.getMonth(), date.getDate());
									const nowOnly = new Date(now.getFullYear(), now.getMonth(), now.getDate());
									const diffTime = nowOnly - dateOnly;
									const diffDays = Math.floor(diffTime / (1000 * 60 * 60 * 24));
									if (diffDays === 0) {
										// Today: show time
										return date.toLocaleTimeString([], { hour: '2-digit', minute: '2-digit' });
									} else if (diffDays === 1) {
										return t('Yesterday');
									} else {
										return t('{{count}} days ago', { count: diffDays });
									}
								};

								const iconClass =
									item.log_value.code === "FLSTART"
										? "fe fe-play"
											: item.log_value.code === "FLEND"
											? "fe fe-check"
												: item.log_value.code === "FLERROR"
												? "fe fe-alert-triangle"
													: item.log_value.code === "FLCREATE"
														? "fe fe-plus-circle"
														: item.log_value.code === "FLUPDATE"
														? "fe fe-check-circle"
															: item.log_value.code === "FLSTATUS"
															? "fe fe-circle"
																: item.log_value.code === "FLDELETE"
																? "fe fe-trash"
										: "fe fe-play";
								return (
									<ListGroup.Item className="px-0 pt-0 border-0 pb-6" key={index}>
										<Row className="position-relative">
											<Col xs="auto">
												<div className="icon-shape icon-md bg-light-primary text-primary rounded-circle">
													<i className={iconClass}></i>
												</div>
											</Col>
											<Col className="ms-n3">
												<h4 className="mb-0 h5">{item.log_value.name}</h4>
												<p
													className="mb-0 text-body small"
													dangerouslySetInnerHTML={{ __html: item.log_value.message }}
												></p>
											</Col>
											<Col xs="auto">
												<span className="text-muted fs-6">{formatTimestamp(item.log_timestamp)}</span>
											</Col>
										</Row>
									</ListGroup.Item>
								);
							})}
						</>
					)}
				</ListGroup>
			</Card.Body>
		</Card>
	);
};
export default RecentActivity;
